import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import '@/plugins'

Vue.config.productionTip = false

Vue.mixin({

  data () {
    return {
      // Temporary Data
      lorem: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren',
      brands: [
        {
          name: 'Savoy Hotel',
          logo: '/assets/logo/savoy.svg',
          desc: null,
          hotels: [
            {
              name: 'Savoy Hotel Boracay Newcoast',
              logo: '/assets/logo/savoy-boracay.svg'
            },
            {
              name: 'Savoy Hotel Mactan Newtown',
              logo: '/assets/logo/savoy-mactan.svg'
            },
            {
              name: 'Savoy Hotel Manila',
              logo: '/assets/logo/savoy-manila.svg'
            }
          ]
        },
        {
          name: 'Richmonde Hotel',
          logo: '/assets/logo/richmonde.svg',
          desc: null,
          hotels: [
            {
              name: 'Eastwood Richmonde Hotel',
              logo: '/assets/logo/richmonde-eastwood.svg'
            },
            {
              name: 'Richmonde Hotel Iloilo',
              logo: '/assets/logo/richmonde-iloilo.svg'
            },
            {
              name: 'Richmonde Hotel Ortigas',
              logo: '/assets/logo/richmonde-ortigas.svg'
            }
          ]
        },
        {
          name: 'Belmont Hotel',
          logo: '/assets/logo/belmont.svg',
          desc: null,
          hotels: [
            {
              name: 'Belmont Hotel Boracay',
              logo: '/assets/logo/belmont-boracay.svg'
            },
            {
              name: 'Belmont Hotel Manila',
              logo: '/assets/logo/belmont-manila.svg'
            }
          ]
        },
        {
          name: 'Homegrown Brands',
          desc: null,
          hotels: [
            {
              name: 'Hotel Lucky Chinatown',
              logo: '/assets/logo/lucky-chinatown.svg'
            },
            {
              name: 'Twin Lakes Hotel',
              logo: '/assets/logo/twin-lakes.svg'
            },
            {
              name: 'Kingsford Hotel Manila',
              logo: '/assets/logo/kingsford.svg'
            }
          ]
        }
      ]
    }
  },

  computed: {
    isMobile () { return this.$vuetify.breakpoint.mdAndDown }

    // website_data () { return this.$store.getters.website_data },
    // label_data () { return this.$store.getters.label_data },
    // roomrate_data () { return this.$store.getters.roomrate_data },

    // cssVars () {
    //   return {
    //     '--color-primary': this.website_data.profile.primary_color,
    //     '--color-secondary': this.website_data.profile.secondary_color,
    //     '--color-primary-rgb': this.HexToRgb(this.website_data.profile.primary_color),
    //     '--color-secondary-rgb': this.HexToRgb(this.website_data.profile.secondary_color),
    //   }
    // },
  },

  methods: {
    formatDate (date) {
      if (date) {
        date = new Date(date)
        return [date.getDate(), date.getMonth(), date.getFullYear()].join('/')
      } else return ''
    }
  }
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
